import React from 'react';
import { OverlayTrigger } from 'react-bootstrap';

const CustomOverlayTrigger = (props) => {
    return (
    <OverlayTrigger placement={props.placement} overlay={props.tooltip}>
        {props.children}
    </OverlayTrigger>
    );
}

export default CustomOverlayTrigger;